import { render } from "./EducationLevel.vue?vue&type=template&id=5c70750a&scoped=true"
import script from "./EducationLevel.vue?vue&type=script&lang=js"
export * from "./EducationLevel.vue?vue&type=script&lang=js"

import "./EducationLevel.vue?vue&type=style&index=0&id=5c70750a&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c70750a"]])

export default __exports__